const MicroProfile = ({username}) => {
  return (
    <>
      <div className="rounded-full bg-yellow-400 text-gray-900 h-10 w-10 flex items-center justify-center text-xl font-bold mr-1 ml-2">
        {username.charAt(0).toUpperCase() || "U"}
      </div>
      <span className="text-sm md:text-lg font-medium capitalize">
        {username || null}
      </span>
    </>
  );
};

export default MicroProfile;
